import { IGSPCommonModel } from './Interface/IGSPCommonModel';
import { RelationForeignKeyConstraint } from './Constraints/RelationForeignKeyConstraint';
import { IGSPCommonObject } from './Interface/IGSPCommonObject';

import { GSPCommonObject } from './GSPCommonObject';
import { CommonVariableEntity } from './Variable/CommonVariableEntity';
import { VersionControlInfo } from './VersionControlInfo/VersionControlInfo';

/**
 * 通用模型，作为业务实体，视图模型和数据模型的总接口，用于规划实体数据结构
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 通用模型，作为业务实体，视图模型和数据模型的总接口，用于规划实体数据结构
 */
export class GSPCommonModel implements IGSPCommonModel {

    /**
     * 唯一标志
     */
    ID: string;

    /**
     * 编号
     */
    Code: string;

    /**
     * 名称
     */
    Name: string;

    /**
     * 是否记录
     */
    IsRecord: boolean;

    /**
     * 记录历史表
     */
    RecordHistoryTable: string;

    /**
     * 日志对象Id
     */
    LogObjectID: string;

    /**
     * 是否虚拟模型
     */
    IsVirtual: boolean;

    /**
     * 主节点主键字段Id
     */
    PrimayKeyID: string;

    /**
     * 是否允许被继承
     */
    IsAllowDerive: boolean;

    /**
     * 是否允许被扩展
     */
    IsAllowExtend: boolean;

    /**
     * 维度
     */
    Dimension: string;

    /**
     * 分级信息
     */
    Hierarchy: string;

    /**
     * 主节点
     */
    MainObject: IGSPCommonObject;

    /**
     * 扩展类型
     */
    ExtendType: string;

    /**
     * 用于序列化处理子模型元数据的扩展属性
     */
    ExtendNodeList: Map<string, string>;

    /**
     * 当前节点字段集合
     */
    FkConstraints: RelationForeignKeyConstraint[];

    /**
     * be生成时使用的程序集名
     */
    GeneratingAssembly: string;

    /**
     * 变量实体
     */
    Variables: CommonVariableEntity;

    /**
     * 是否使用命名空间+编号的ConfigId
     * 以前建的为false，保证原有代码可用
     * 新建元数据为true，保证后续元数据ConfigId唯一
     */
    IsUseNamespaceConfig: boolean;

    VersionControlInfo: VersionControlInfo;

    /**
     * 标签
     */
    BeLabel: string[];
    // /**
    //  * 根据elementId查找字段
    //  * @param id
    //  */
    // public findElementById(elementId: string): IGSPCommonElement {
    //     let result: IGSPCommonElement = null;
    //     result = this.findElementFromObjectByID(this.MainObject, elementId);
    //     return result;
    // }

    /**
     * 根据objId查找对象
     * @param objId
     */
    public findObjectById(objId: string): GSPCommonObject {
        let result: GSPCommonObject = null;
        result = this.findObjectFromObjectByID(this.MainObject, objId);
        return result;
    }

    // // public getAllObjectList(): IGSPCommonObject[] {
    // //     throw new Error('Method not implemented.');
    // // }

    // public getAllElementList(): IGSPCommonElement[] {
    //     return this.MainObject.getAllObjectElement();
    // }



    // private findElementFromObjectByID(obj: IGSPCommonObject, id: string): IGSPCommonElement {
    //     let result: IGSPCommonElement = null;
    //     //查找当前节点字段集合
    //     for (let i = 0; i < obj.ContainElements.length; i++) {
    //         if (obj.ContainElements[i].ID == id) {
    //             result = obj.ContainElements[i];
    //             return result;
    //         }
    //     }

    //     //递归查找子节点
    //     if (obj.ContainChildObjects.length > 0) {
    //         for (let i = 0; i < obj.ContainChildObjects.length; i++) {
    //             result = this.findElementFromObjectByID(obj.ContainChildObjects[i], id);
    //             if (result != null) {
    //                 return result;
    //             }
    //         }
    //     }
    //     return result;
    // }

    // private findElementFromElementByID(ele: IGSPCommonElement, eleId: string): IGSPCommonElement {
    //     let result: IGSPCommonElement = null;

    //     if (ele.ID == eleId) {
    //         result = ele;
    //     }
    //     else {
    //         //查找所有关联字段及关联的关联字段……
    //         if (ele.HasAssociation) {
    //             for (let i = 0; i < ele.ChildAssociations.length; i++) {
    //                 let asscociation = ele.ChildAssociations[i];
    //                 for (let j = 0; j < asscociation.RefElementCollection.length; j++) {
    //                     let element = this.findElementFromElementByID(asscociation.RefElementCollection[i], eleId);
    //                     if (element != null) {
    //                         result = element;
    //                         return result;
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     return result;
    // }

    private findObjectFromObjectByID(obj: IGSPCommonObject, objId: string): any {
        let result: IGSPCommonObject = null;

        if (!obj) {
            return null;
        }

        if (obj.ID === objId) {
            return obj;
        }

        if (!obj.ContainChildObjects) {
            return null;
        }
        // 递归查找子节点
        if (obj.ContainChildObjects.length > 0) {
            for (let i = 0; i < obj.ContainChildObjects.length; i++) {
                if (obj.ContainChildObjects[i].ID === objId) {
                    result = obj.ContainChildObjects[i];
                    return result;
                }

                result = this.findObjectFromObjectByID(obj.ContainChildObjects[i], objId);
                if (result != null) {
                    return result;
                }
            }
        }

        return result;
    }
    /**
     * 获取节点列表
     * @param obj 
     * @param objectArray 
     * @returns 
     */
    public getObjectList(obj: IGSPCommonObject, objectArray: IGSPCommonObject[]): void {
        objectArray.push(obj);
        const childObjects = obj.ContainChildObjects;
        if (!childObjects || childObjects.length == 0) {
          return;
        }
        for (let i = 0; i < childObjects.length; i++) {
          this.getObjectList(childObjects[i], objectArray);
        }
    }
}
